// 防抖(可立即执行和取消）
export function debounce(func, wait, immediately) {
  let timer;
  let debounced = function (...args) {
    let result;
    // 清除闹钟后，闹钟还是存在的
    if (timer) clearTimeout(timer);
    if (immediately) {
      let called = !timer;
      timer = setTimeout(() => {
        timer = null;
      }, wait);
      if (called) {
        result = func.apply(this, args);
      }
    } else {
      timer = setTimeout(() => {
        func.apply(this, args);
      }, wait);
    }
    return result;
  };
  debounced.cancel = function () {
    clearTimeout(timer);
    timer = null;
  };
  return debounced;
}
export function throttle(func, delay) {
  var timer = null;
  var startTime = Date.now();
  return function () {
    var curTime = Date.now();
    var remaining = delay - (curTime - startTime);
    var context = this;
    clearTimeout(timer);
    if (remaining <= 0) {
      func.apply(context, arguments);
      startTime = Date.now();
    } else {
      timer = setTimeout(func, remaining);
    }
  };
}
export function copy(val = "") {
  //使用textarea才可以换行
  let textarea = document.createElement("textarea");
  textarea.value = val;
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand("Copy");
  textarea.parentNode.removeChild(textarea);
}
export function preloadImages(imagesArray) {
  console.log(imagesArray)
  const promises = imagesArray.map((src) => {
      return new Promise((resolve, reject) => {
          const img = new Image();
          img.src = src;
          img.onload = resolve;
          img.onerror = reject;
      });
  });

  return Promise.all(promises);
}